module.exports = __webpack_public_path__ + "img/J10570.3e7af815.png";